import { WsApi } from "@/utils/http-client";

export default {
  generateForm(transactionId) {
    return WsApi.post("/api/paymentflow/v1/secure-form/generate", { transactionId });
  },
  getCardDetails(transactionId, customerId) {
    return WsApi.get("/api/paymentflow/v1/masked-payment-details/generate", { transactionId, customerId });
  },
};
